"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Désormais Concur fait partie de SAP.',
    learn: {
      href: '/sap',
      text: ' En savoir plus'
    }
  },
  social: [{
    network: 'facebook',
    href: ''
  }, {
    network: 'twitter',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }],
  support: {
    links: [{
      text: 'BLOGUE CONCUR',
      href: ''
    }, {
      text: 'NOUS CONTACTER',
      href: '/fr/contact'
    }],
    selector: 'SÉLECTEUR DE PAYS',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: 'Politique sur la vie privé',
      href: '/privacy-policy'
    }, {
      text: "Conditions d'utilisation",
      href: ''
    }]
  }
};